import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Screens } from '../screencontainer.js';
//import { apiURL, apiURL_QA } from '../api.js';
import '../index.css';
import { API } from '../api.js';
import { Spinner } from 'react-bootstrap';
import { VERIFY_CODE, VERIFY_CODE_RESEARCH, PROCESS_GET_SERVICE_URL_GIZMO_REACT } from '../actions';

export class OTPVerification extends React.Component {

    constructor( props ) {
        super( props );

        this.state = {
            userInput: '',
            validated: false,
            validationError: false,
            errorMessage: '',
            showError: false,
            disableButton: false,
            isLoading: false,
            apiURL: '',
            apiURL_QA: ''
        }
    }

    onChange = ( event ) => {

        let value = event.target.value;
        let maxLength = event.target.maxLength;

        value = value.slice( 0, maxLength );

        this.setState({ userInput: value });
    }
    
    onSubmit = async ( event ) => {

        
        event.preventDefault();
        event.stopPropagation();

        let codeRegEx = /\d\d\d\d\d/;
        let api = new API();

        this.setState({ isLoading: true });
        
        if ( this.state.userInput.match( codeRegEx ) ) {
            this.setState({ validationError: false });

            let requestDataParams = {
                'RequestGuid': this.props.guid,
                'Code': this.state.userInput,
                'UserAction': this.props.userAction,
                'SessionId': this.props.sessionID
            }

            let requestData = null;

            if(this.props.userAction === 'Research Access') {
                requestData = api.createRequestData(VERIFY_CODE_RESEARCH, requestDataParams );
            }else {
                requestData = api.createRequestData(VERIFY_CODE, requestDataParams ); 
            }
            
            let encryptedRequestData = api.encryptData( requestData );
            let request              = api.createRequest( encryptedRequestData );
            let requestOptions       = api.createRequestOptions( 'POST', request );

            try {
                const response = await fetch( this.state.apiURL, requestOptions );
                const data = await response.json();

                let decryptedData = api.decryptData( data[ 'Data' ] );
                let decryptedToJSON = JSON.parse( JSON.parse( decryptedData )[ 'ResponseList' ][ 'Response'] );

                let messageId  = decryptedToJSON['Messages'][0]['MsgId'];
                let messageStatus = decryptedToJSON['Messages'][0]['MsgStatus'];
                let callingUserId = decryptedToJSON['Messages'][0]['PersonId'];
                let taskId = this.props.userAction === 'Research Access' ? undefined : decryptedToJSON['Messages'][0]['TaskId'];

                if (messageId === '0' && messageStatus === 'OK' && callingUserId !== '' && taskId !== '') {

                    switch(this.props.userAction) {
                        case 'Check Site Access':
                        case 'Research Access':
                            let fullURL = decryptedToJSON['ProgramIdList'][0][ 'ProgramSessionURL'].replace('######', decryptedToJSON['ProgramIdList'][0]['ProgramSessionId']);
                            window.open( fullURL, "_self" );
                        break;

                        case 'New Site Access':

                            let reqOptions = api.createRequestOptions('POST', api.createRequest_QA(api.encryptData(api.createRequestData(PROCESS_GET_SERVICE_URL_GIZMO_REACT, {
                                'TaskId': taskId,
                                'CallingUserId': callingUserId,
                                'ProxyActionContext':'CreateSurveyInstance' 
                            }))));
                            
                            const res = await fetch(this.state.apiURL_QA, reqOptions);
                            const data = await res.json();

                            let decryptedResponse = api.decryptData(data['Data']);
                            let decryptedResponseToJSON = JSON.parse(JSON.parse(decryptedResponse)['ResponseList']['Response']);

                            if(decryptedResponseToJSON['Messages'][0]['MsgStatus'] === 'SUCCESS' && decryptedToJSON['Messages'][0]['MsgId'] == '0') {

                                //let gizmoSurveyInstanceId = decryptedResponseToJSON["Targets"][0]['GizmoSurveyInstanceId'];
                                let reqObj = {
                                    'TaskId': taskId, 
                                    'CallingUserId' : callingUserId,
                                    'ProxyActionContext' : 'GetServiceURLForGizmo_eCyclops'
                                };
                            
                                let requestOptions1 = api.createRequestOptions( 'POST', api.createRequest_QA(api.encryptData(api.createRequestData(PROCESS_GET_SERVICE_URL_GIZMO_REACT, reqObj))));
                                
                                const response = await fetch(this.state.apiURL_QA, requestOptions1);
                                const responseData = await response.json();
                         
                                let decryptedResponseData = api.decryptData(responseData['Data']);
                                let decryptedResponseDataToJSON = JSON.parse( JSON.parse(decryptedResponseData)['ResponseList']['Response']);
                                
                                if(decryptedResponseToJSON['Messages'][0]['MsgStatus'] === 'SUCCESS') {

                                    let targetURL = decryptedResponseDataToJSON['Targets'][0]['TargetURL'];
                                    let serviceURL = targetURL !== '' ? targetURL : 'https://healthconnect.rwjbh.org';  
            
                                    window.open( serviceURL, "_self" );

                                } else {
                                    this.setState({ validationError: true, isLoading: false });
                                }
                            } else {
                                this.setState({ validationError: true, isLoading: false });
                            }

                        break;

                        case 'Update Site Access':

                            let requestOpts = api.createRequestOptions('POST', api.createRequest_QA(api.encryptData(api.createRequestData(PROCESS_GET_SERVICE_URL_GIZMO_REACT, {
                                'TaskId': taskId, 
                                'CallingUserId' : callingUserId,
                                'ProxyActionContext' : 'GetServiceURLForGizmo_eCyclops'
                            }))));

                            const response = await fetch(this.state.apiURL_QA, requestOpts);
                            const responseData = await response.json();
                            let decryptedResponseData = api.decryptData( responseData[ 'Data' ] );
                            let decryptedResponseDataToJSON = JSON.parse( JSON.parse(decryptedResponseData)[ 'ResponseList' ][ 'Response'] );

                            if(decryptedResponseDataToJSON[ 'Messages' ][ 0 ][ 'MsgStatus' ] === 'SUCCESS') {

                                let targetURL = decryptedResponseDataToJSON['Targets'][0]['TargetURL'];
                                let serviceURL = targetURL !== '' ? targetURL : 'https://healthconnect.rwjbh.org';  
        
                                window.open( serviceURL, "_self" );

                            } else {
                                this.setState({ validationError: true, isLoading: false });
                            }

                        break;
                        
                        default:
                           console.log("User Action Not Defined!");
                        break;
                        
                    }// END OF SWITCH STATEMENT

                    this.setState({ showError: false });

                } else if (decryptedToJSON['Messages'][0]['MsgStatus'] === 'FAILED') {

                    let msg = decryptedToJSON['Messages'][0]['Msg'];
                    let id  = decryptedToJSON['Messages'][0]['MsgId'];

                    this.setState({ errorMessage: msg, showError: true, isLoading: false});

                    // email already associated with account (new request) or not associated with any account (update request) || exceeded retries
                    if ( id === '-90' || id === '-9999' ) {
                        this.setState({ disableButton: true, isLoading: false });
                    }
                }
            }
            catch ( e ) { 
                this.setState({ isLoading: false });
            }
        } else { 
            this.setState({ validationError: true, isLoading: false });
        }

        this.setState({ validated: true });
    } // End of onSubmit function

    onCancel = () => { 
        this.props.setScreenState( Screens.VERIFICATION, this.props.userAction, null );
    }
    

    render() {
        
        if(this.state.apiURL === '' && this.state.apiURL_QA === '') {
            this.setState({ apiURL: this.props.apiURLs.apiURL, apiURL_QA: this.props.apiURLs.apiURL_QA});
        }

        return(
            <>
                <p className='VerificationDisclaimer'>
                    Verification code was sent to the email provided: <b>{this.props.email}</b>
                </p>
                <br></br>
                {/* <h6 className='VerificationDisclaimer'>
                    Enter the code you recieved below:
                </h6> */}

                <Form
                    className='VerificationEmailProperties'
                    noValidate
                    validated={this.state.validated}
                    onSubmit={this.onSubmit}
                >
                    <Form.Group>
                        <Form.Control 
                            required
                            type='number'
                            maxLength={5}
                            pattern='.{5,}'
                            className='shadow OTPInputFormatting'
                            placeholder='enter verification code'
                            value={this.state.userInput}
                            onChange={this.onChange}
                        />

                        <p
                            className='OTPValidationError'
                            hidden={!this.state.validationError}
                        >
                            Please enter a 5 digit code
                        </p>

                        <p
                            hidden={!this.state.showError}
                            className='VerificationEmailMatchError'
                            style={{marginTop:'15px'}}
                        >
                        
                            { this.state.errorMessage }

                        </p>

                        <div className='VerificationSubmitButtonFormatting'>
                            {
                                this.state.isLoading ?

                                    <center>
                                        <Spinner className='Spinner' animation='border' />
                                    </center>
                                :

                                <Button
                                    disabled={this.state.disableButton}
                                    variant='danger'
                                    type='submit'
                                    className='VerificationSubmitButtonProperties shadow'
                                >
                                    Verify
                                </Button>
                            }

                            <Button
                                variant='link'
                                className='VerificationCancelButton'
                                onClick={this.onCancel}
                            >
                                Go Back
                            </Button>
                        </div>
                    </Form.Group>
                </Form>
            </>
        );
    }
}